// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ExternalLink } from '@/components/external-link';
import {
  ShippingCarrier,
  getTrackingLabelForShippingCarrier,
  getTrackingURLForShippingCarrier,
} from '@/constants/shipping-carrier';
import { Typography } from '@mui/material';

interface TransportRefLabelProps {
  carrier: ShippingCarrier | null;
  carrierName: string | null;
  trackingNumber: string | null;
}

export function TransportRefLabel(props: TransportRefLabelProps) {
  const name =
    props.carrier === 'other' ? props.carrierName || 'Other' : undefined;
  const label = getTrackingLabelForShippingCarrier(
    props.carrier,
    props.trackingNumber,
    name ? { name } : undefined
  );
  const trackingUrl =
    props.carrier && props.trackingNumber
      ? getTrackingURLForShippingCarrier(props.carrier, props.trackingNumber)
      : null;

  if (!label) {
    return null;
  }

  // A carrier and its tracking number are a phrase, not a paragraph, so this
  // sits inside a line of text as readily as it sits on its own
  return (
    <Typography variant="body2" component="span">
      {trackingUrl ? (
        <ExternalLink href={trackingUrl}>{label}</ExternalLink>
      ) : (
        label
      )}
    </Typography>
  );
}
